export const sectorEntityConfig = {
    entityType: 'sectors',
    entityFormattedTitle: 'Sectors',
    entityCataloguePath: '/sectors',
    entityCatalogueConfig: {
        constants: {},
    },
    entityDashboardConfig: {
        constants: {},
        isSavePDFEnabled: false,
        isSubjectMatterDetailsSummaryEnabled: true,
    },
};
